import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEditBig: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="edit-big, box, pencil, pen, write, draw"><path d="M8.75 15.25V12.25L18 3L21 6L11.75 15.25H8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 3.75H3.75V20.25H20.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEditBig;
